import { render, staticRenderFns } from "./DeliveryPartnerRegistration.vue?vue&type=template&id=37185d60&scoped=true&"
import script from "./DeliveryPartnerRegistration.vue?vue&type=script&lang=js&"
export * from "./DeliveryPartnerRegistration.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPartnerRegistration.vue?vue&type=style&index=0&id=37185d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37185d60",
  null
  
)

export default component.exports